export const APP_NAME = 'collections-portal';

export const INHOUSE_AGENCY_CODE = 1000;
export const HRC_AGENCY_CODE = 'HRC';
